import type { MappingReviewMapping } from "../../components/catalog/MappingTableRow";
import {
  MAPPING_REVIEW_STATUS_OPTIONS,
  type MappingReviewStatus,
} from "./constants";

function toStatus(value: unknown): MappingReviewStatus {
  const normalized = String(value ?? "pending");
  return MAPPING_REVIEW_STATUS_OPTIONS.some(
    (status) => status.value === normalized,
  )
    ? (normalized as MappingReviewStatus)
    : "pending";
}

/**
 * Map a raw row to MappingReviewMapping. One function per file (single method per file).
 */
export function toMappingReviewMapping(
  row: Record<string, unknown>,
  id: string,
): MappingReviewMapping {
  return {
    id,
    marketplace: String(row.marketplace ?? ""),
    productType: String(row.productType ?? ""),
    displayName: String(row.displayName ?? ""),
    canonicalCategory:
      row.canonicalCategory != null ? String(row.canonicalCategory) : null,
    status: toStatus(row.status),
    approvalSyncRetryable: row.approvalSyncRetryable === true,
    mappedAt: row.mappedAt != null ? String(row.mappedAt) : null,
    mappedBy: row.mappedBy != null ? String(row.mappedBy) : null,
    confidence: typeof row.confidence === "number" ? row.confidence : null,
    totalBlocked:
      typeof row.totalBlocked === "number" ? row.totalBlocked : null,
    mappingSessionId:
      row.mappingSessionId != null ? String(row.mappingSessionId) : null,
    createdAt: row.createdAt != null ? String(row.createdAt) : null,
    updatedAt: row.updatedAt != null ? String(row.updatedAt) : null,
  };
}
